// Reveal Image animation component
const RevealImageAnimation = () => {
    // Getting motion
    const { animate, inView } = Motion;

    // Animation
    const animation = (element, path) => {
        animate(
            element,
            {
                clipPath: path
            },
            {
                ease: "circleInOut",
                duration: 1,
            }
        );
    };

    if (window.innerWidth > 1199.98) { 
        // On scroll
        inView(".revealImageUp", (e) => animation(e, ["inset(100% 0 0 0)", "inset(0 0 0 0)"]));
        inView(".revealImageDown", (e) => animation(e, ["inset(0 0 100% 0)", "inset(0 0 0 0)"]));
        inView(".revealImageLeft", (e) => animation(e, ["inset(0 100% 0 0)", "inset(0 0 0 0)"]));
        inView(".revealImageRight", (e) => animation(e, ["inset(0 0 0 100%)", "inset(0 0 0 0)"]));
    }
};

// Export component
export default RevealImageAnimation;